<p>
  <strong>Pro Tip:</strong> Link code commits with errors to pinpoint
  regressions or an error origin.
</p>
<a
  uiSref="project-deploys"
  class="btn btn--success btn--default"
  (click)="dismissCallout()"
>
  Set up Deploys
</a>
